exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-2ff5c9ee]{cursor:pointer}p[data-v-2ff5c9ee]:hover{text-decoration:underline}", ""]);

// exports
